<template>
  <el-dialog
    :title="$t('editServiceProvide.editServiceProvide')"
    :visible.sync="dialogVisible"
    width="80%"
    :before-close="handleClose">
    <el-form :model="editServiceProvideInfo" label-width="120px">
      <el-form-item :label="$t('editServiceProvide.serviceName')" required>
        <el-input 
          v-model="editServiceProvideInfo.name" 
          :placeholder="$t('editServiceProvide.inputServiceName')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('editServiceProvide.serviceCode')" required>
        <el-input 
          v-model="editServiceProvideInfo.serviceCode" 
          :placeholder="$t('editServiceProvide.inputServiceCode')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('editServiceProvide.params')" required>
        <el-input 
          v-model="editServiceProvideInfo.params" 
          :placeholder="$t('editServiceProvide.inputParams')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('editServiceProvide.implementMethod')" required>
        <el-select 
          v-model="editServiceProvideInfo.queryModel" 
          :placeholder="$t('editServiceProvide.selectImplementMethod')"
          style="width:100%">
          <el-option :label="$t('editServiceProvide.selectImplementMethod')" value="" disabled></el-option>
          <el-option label="sql方式" value="1"></el-option>
          <el-option label="java方式" value="3"></el-option>
          <el-option :label="$t('editServiceProvide.storedProcedure')" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="editServiceProvideInfo.queryModel==1" label="sql">
        <el-input
          type="textarea"
          :rows="10"
          :placeholder="$t('editServiceProvide.inputSql')"
          v-model="editServiceProvideInfo.sql">
        </el-input>
      </el-form-item>

      <el-form-item v-if="editServiceProvideInfo.queryModel==1" :label="$t('editServiceProvide.outputTemplate')">
        <el-input
          type="textarea"
          :rows="10"
          :placeholder="$t('editServiceProvide.inputTemplate')"
          v-model="editServiceProvideInfo.template">
        </el-input>
      </el-form-item>

      <el-form-item v-if="editServiceProvideInfo.queryModel==2" :label="$t('editServiceProvide.storedProcedure')">
        <el-input
          type="textarea"
          :rows="10"
          :placeholder="$t('editServiceProvide.inputStoredProcedure')"
          v-model="editServiceProvideInfo.proc">
        </el-input>
      </el-form-item>

      <el-form-item v-if="editServiceProvideInfo.queryModel==3" label="java">
        <el-input
          type="textarea"
          :rows="10"
          :placeholder="$t('editServiceProvide.inputJava')"
          v-model="editServiceProvideInfo.javaScript">
        </el-input>
      </el-form-item>

      <el-form-item :label="$t('editServiceProvide.description')">
        <el-input
          type="textarea"
          :placeholder="$t('editServiceProvide.inputDescription')"
          v-model="editServiceProvideInfo.remark">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editServiceProvide">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateServiceProvide } from '@/api/dev/serviceProvideApi'

export default {
  name: 'EditServiceProvide',
  data() {
    return {
      dialogVisible: false,
      editServiceProvideInfo: {
        id: '',
        name: '',
        serviceCode: '',
        params: '',
        queryModel: '',
        sql: '',
        template: '',
        proc: '',
        javaScript: '',
        remark: ''
      }
    }
  },
  methods: {
    open(serviceProvide) {
      this.editServiceProvideInfo = {...serviceProvide}
      this.dialogVisible = true
    },
    handleClose(done) {
      this.$confirm(this.$t('editServiceProvide.closeConfirm'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        done()
      }).catch(() => {})
    },
    async editServiceProvide() {
      if (!this.validateForm()) {
        return
      }
      try {
        await updateServiceProvide(this.editServiceProvideInfo)
        this.$message.success(this.$t('editServiceProvide.updateSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('更新服务提供失败:', error)
      }
    },
    validateForm() {
      if (!this.editServiceProvideInfo.name) {
        this.$message.error(this.$t('editServiceProvide.serviceNameRequired'))
        return false
      }
      if (!this.editServiceProvideInfo.serviceCode) {
        this.$message.error(this.$t('editServiceProvide.serviceCodeRequired'))
        return false
      }
      if (!this.editServiceProvideInfo.params) {
        this.$message.error(this.$t('editServiceProvide.paramsRequired'))
        return false
      }
      if (!this.editServiceProvideInfo.queryModel) {
        this.$message.error(this.$t('editServiceProvide.implementMethodRequired'))
        return false
      }
      return true
    }
  }
}
</script>